import { hasTabletUserAgentToken } from './isTabletUserAgent';

/**
 * True when the User-Agent string indicates a mobile phone (not tablet). Tablets are excluded
 * first: iPads and some Silk/Kindle UAs carry a `Mobile` token that would otherwise match.
 */
export function isMobilePhoneUserAgent(rawUserAgent: string): boolean {
    const userAgent = rawUserAgent.toLowerCase();

    return (
        !hasTabletUserAgentToken(userAgent) &&
        /mobile|android.*mobile|iphone|ipod|windows phone/i.test(userAgent)
    );
}
